import { Component } from '@angular/core';
import { SOLUTION_PAGE_CONFIGS } from 'src/app/shared/components/solution-page/solution-page.config';

@Component({
  selector: 'app-solution2',
  templateUrl: './solution2.component.html',
  styleUrls: ['./solution2.component.scss'],
})
export class Solution2Component {
  readonly pageConfig = SOLUTION_PAGE_CONFIGS[2];
}
